<template>
    <div class="st-main-content">
        <div class="layoutTop">
            <el-button type="success" @click="count">一键计算</el-button>
            <span>选中数量：{{selectedList.length}}</span>
        </div>
        <div class="mapBox">
            <div class="map" id="map">
				<baidu-map class="bm-view" center="中山市"  :zoom="zoom" ak="YOUR_APP_KEY">
					<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                    <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
                    <bm-marker :position="item" :dragging="true" v-for="(item,index) in orderList " @click="clickHandler(this,item,index)" :icon="{url:item.isSelected?require('../../assets/images/locaton.png'):require('../../assets/images/locat.png'),size: {width: 35, height: 35},imageSize:{width: 35, height: 35}}" >
                        <bm-label :content="item.consignShortAddress"  :labelStyle="{color: item.isSelected?'#FF5B3E':'blue', borderColor: item.isSelected?'#FF5B3E':'blue', fontSize : '12px'}"  :offset="{width: 0, height: 35}" />
                    </bm-marker>
  				</baidu-map>
			</div>
        </div>

        <el-dialog title="提示" :modal-append-to-body='false' :visible.sync="dialogVisible" center width="35%">
            <div slot="title" class="dialog-title">
                <p>总距离：<span class="">{{totalDistance}}KM</span></p>
                <p>总方数：<span class="">{{totalVolume}}m<sup style="vertical-align: super;">3</sup></span></p>
            </div>
            <div class="dialog-content">
                <div class="dialog-content-item" v-for="(item, index) in coutResultArr" :key="index">
                    <div class="dialog-content-item-left">
                        <div class="dialog-content-item-text">{{index+1}}</div>
                        <div class="dialog-content-item-line"></div>
                    </div>
                    <div class="dialog-content-item-right">{{item.consignShortAddress}}({{item.countDistance || 0}}km)
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="dialog-top-section">
                    <div class="input-item">
                        <span>货物名称:</span>
                        <el-select v-model="curCountObj.goodsName" placeholder="请选择" size="mini"
                            @change="goodsNameChange">
                            <el-option v-for="item in goodsList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input-item">
                        <span>车型:</span>
                        <el-select v-model="curCountObj.vehicleId" placeholder="请选择" size="mini">
                            <el-option v-for="item in vehicleList" :key="item.id" :label="item.model" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input-item">
                        <span>预约提货时间:</span>
                        <el-date-picker v-model="curCountObj.pickupTime"   type="datetime" size="mini"
                            :default-value="new Date()" :clearable="false" placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="dialog-top-section">
                    <div class="input-item">
                        <span>选择司机派送:</span>
                        <el-select class="car-select" size="mini" v-model="driverId" filterable remote reserve-keyword placeholder="请输入车牌号码"
                            :remote-method="searchCar" :loading="searchCarLoading">
                            <el-option v-for="item in searchCarList" :key="item.id" :label="item.carNo"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div>
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="waybillCreate(true)">价格预览</el-button>
                    <el-button type="primary" @click="waybillCreate()">一键下单</el-button>
                </div>
            </span>
        </el-dialog>
        <el-dialog :modal-append-to-body='false' :visible.sync="payDialog" center width="30%">
            <div class="payDialog-content">
                <div ref="qrCodeUrl" class="pay-qrcode"></div>
                <div>运费：<span class="pay-success">{{paySuccessObj.ownerExpressFee}}元</span></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div>
                    <el-button type="success" @click="checkPayStatus()">确定支付成功</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import stDialog from '../../components/StDialog'
import QRCode from 'qrcodejs2'
export default {
    name:'OrderMap',
    components: {BaiduMap},
    data(){
        return{
            zoom:13,
            center:{
                lat: 23.118542,
                lng: 113.206041
            },
            orderParams:{},


            vehicleValue: '',
            goodsNameValue: '',
            payDialog: false,
            coutResultArr: [],
            curCountObj: {
                goodsName: '',
                vehicleId: '',
                pickupTime: new Date(),
                paymentType: 0,
            },
            searchCarLoading: false,
            searchCarList: [],
            driverId: '',
            dialogVisible: false,
            multipleSelection: [],
            selectedList: [],
            orderList: [],
            vehicleList: [],
            goodsList: [],
            totalDistance: 0,
            totalVolume: 0,
            waybillObj: {

            },
            paySuccessObj: {
                url: '',
                money: 0
            },
            checkTimer: null,
            payWaybillNo: '',
            waybillPaymentType: null, // 用户支付类型
        }
    },
    components:{stDialog},
    mounted(){
        let mapBox=document.getElementById('map')
        if (mapBox.addEventListener){
            mapBox.addEventListener('DOMMouseScroll', this.wheel, false);
        }
        mapBox.onmousewheel = mapBox.onmousewheel = this.wheel;
        this.orderParams=this.$route.params.orderParams;
        this.getGoodsList()
        this.getData()
    },
    methods:{
         wheel(event){
            var delta = 0;
            if (!event) event = window.event;
            if (event.wheelDelta) {
                delta = event.wheelDelta/120; 
                if (window.opera) delta = -delta;
            } else if (event.detail) {
                delta = -event.detail/3;
            }
            if (delta){
                this.handle(delta);
            }
        },
        handle(delta) {
            if (delta <0){
                if(this.zoom>0){
                    this.zoom--
                }
            }else{
                if(this.zoom<20){
                    this.zoom++
                }
            }
        },
        getData() {
			const sendData = {
				...this.orderParams
			}
            sendData.notSee=true;
            sendData.waybillState=0;
            sendData.size=999999;
            const that=this;
			this.$server.business.waybillPage(sendData, (res) => {
                this.orderList=res.data.records;
                    that.resetSelectList()
			})
        },
        
        clickHandler(e,item,index){
            this.selectedChange(index)
        },
        searchCar(query) {
            this.searchCarLoading = true
            let data = {};
            data.userType = 2; //司机
            data.current = 1;
            data.size = 1000;
            data.isAudit = 1
            data.carNo = query || ''
            this.$server.business.userPage(data, (res) => {
                this.searchCarLoading = false
                if (res.code == 0) {
                    // 处理只显示未接单和已认证的司机
                    this.searchCarList = res.data;
                } else {
                    this.$toast.stMessage(res.message, false)
                }
            })
        },

        goodsNameChange(value) {
            const curItem = this.goodsList.find((item) => {
                return item.id === value
            })

            this.curCountObj.goodsName = curItem.name
            this.curCountObj.goodsId = curItem.id
        },
        waybillCreate(isView) {
            const curSendData = JSON.parse(JSON.stringify(this.coutResultArr))
            curSendData.forEach((item, index) => {
                item.sort = index
                item = Object.assign(item, item.consign)
            })

            let waybillConsign = curSendData.splice(0, 1)[0]
            const waybillNoArr = []
            this.selectedList.forEach(item => {
                waybillNoArr.push(item.waybillNo)
            })
            if (isView) {
                this.$server.business.waybillPriceView({
                    secondary: waybillNoArr,
                    waybill: this.curCountObj,
                    waybillConsign: waybillConsign,
                    waybillReceiveList: curSendData,
                    driverId: this.driverId,
                    isDesignate: !!this.driverId 
                }, res => {
                    this.$toast.stMessage(`货主运费：${res.data.ownerExpressFee}元`,"success")
                })
            } else {
                this.$server.business.waybillCreate({
                    secondary: waybillNoArr,
                    waybill: this.curCountObj,
                    waybillConsign: waybillConsign,
                    waybillReceiveList: curSendData,
                    driverId: this.driverId,
                    isDesignate: !!this.driverId 
                }, res => {
                    this.$toast.stMessage('下单成功~', true)
                    this.paySuccessObj = res.data
                    this.dialogVisible = false
                    this.payWaybillNo = res.data.waybillNo

                    this.checkPayType()
                })
            }
        },

        checkPayType() {
            // 判断用户支付类型 如果是月结则直接成功
            if (this.waybillPaymentType == 2) {
                this.$alert('月结用户，下单成功', {
                    callback: action => {
                        this.reSetData()
                        this.$store.dispatch('common/deleteTab')
                    }
                })
                return
            } else {
                // 寄付或到付直接获取微信支付url给用户支付
                this.wxPay()
            }
        },
        wxPay() {
            this.$server.business.wxpay(this.payWaybillNo, res => {
                this.payDialog = true
                this.$nextTick(() => {
                    this.$refs.qrCodeUrl.innerHTML = ''
                    new QRCode(this.$refs.qrCodeUrl, {
                        text: res.data.codeUrl,
                        width: 170,
                        height: 170,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: QRCode.CorrectLevel.H
                    })
                })
                this.checkPayStatus()
            })
        },

        checkPayStatus() {
            this.checkTimer && clearTimeout(this.checkTimer)
            this.checkTimer = setTimeout(() => {
                this.$server.business.checkPayStatus(this.payWaybillNo, res => {
                    if (res.data.state === 'SUCCESS') {
                        this.$toast.stConfirm2({
                            msg: '支付成功',
                            showCancel: false
                        }).then(res => {
                            this.checkTimer && clearTimeout(this.checkTimer)
                            this.reSetData()
                            this.$store.dispatch('common/deleteTab')
                        })

                    } else {
                        this.checkPayStatus()
                    }
                })
            }, 2000)
        },

        reSetData() {
            this.dialogVisible = false
            this.payDialog = false
            this.selectedList = []
            this.coutResultArr = []
            this.orderList = []
        },
        resetSelectList() {
            this.selectedList = []
            this.coutResultArr = []
            this.orderList.forEach((item, index) => {
                item.isSelected = false;
                item.lng=item.consign.longitude
                item.lat=item.consign.latitude
                delete item.selectedIndex
            })
            this.refreshOrderList()
        },
        getGoodsList() {
            this.$server.business.getGoodsList(res => {
                this.goodsList = res.data
            })
        },
        getUserInfo() {
            return new Promise((resolve, reject) => {
                this.$server.business.getCurUserInfo((res) => {
                    resolve(res)
                })
            })
        },

        sortChange() {
            this.resetSelectList()
        },

        count() {
            if (this.selectedList.length == 0) {
                return this.$toast.stMessage('请选择需要计算的订单', true)
            }
            this.getVehicleList()
            this.initData()
            this.searchCar()
            this.getDistance()
        },

        initData() {
            // 初始化车辆等参数
            this.driverId = ''
            this.curCountObj.pickupTime = ''
            this.curCountObj.vehicleId = ''
            this.curCountObj.goodsName = ''
        },

        async getDistance() {
            const sendData = []
            this.coutResultArr = JSON.parse(JSON.stringify(this.selectedList))
            this.coutResultArr.forEach(item => {
                sendData.push({
                    lat: item.consign.latitude,
                    lon: item.consign.longitude
                })
            })
            const userInfo = await this.getUserInfo()
            this.waybillPaymentType = userInfo.data.waybillPaymentType
            this.coutResultArr.push({
                consignShortAddress: userInfo.data.shortAddress,
                areaCode: userInfo.data.areaCode,
                areaName: userInfo.data.areaName,
                cityCode: userInfo.data.cityCode,
                cityName: userInfo.data.cityName,
                contactPhone: userInfo.data.contactPhone,
                contactSubject: userInfo.data.contactSubject,
                fullAddress: userInfo.data.fullAddress,
                latitude: userInfo.data.latitude,
                longitude: userInfo.data.longitude,
                provinceCode: userInfo.data.provinceCode,
                provinceName: userInfo.data.provinceName,
                shortAddress: userInfo.data.shortAddress,
            })
            
            this.$server.business.countDistance(sendData, res => {
                let distance = 0
                let volume = 0
                for (let i = 1; i < this.coutResultArr.length; i++) {
                    this.coutResultArr[i].countDistance = res.data[i - 1].distance
                    distance += res.data[i - 1].distance
                    volume += this.coutResultArr[i - 1].volume
                }
                this.totalVolume = volume.toFixed(2)
                this.totalDistance = distance.toFixed(2)
                this.coutResultArr = JSON.parse(JSON.stringify(this.coutResultArr))
                this.dialogVisible = true
            })
        },

        getVehicleList() {
            
            let data={};
            data.cityCode=this.selectedList[0].consign.cityCode;
            this.$server.business.getVehicleList(data,res => {
                this.vehicleList = res.data
            })
        },

        

        selectedListItemRemove(item) {
            /*
                * 用orderList 每一项的selectedIndex 来显示对应的顺序
                用selectedList来表示选中的数据 已经排好序的
                麻烦的是对应删除的操作步骤
                1.获取当前要删除的curIndex
                2.吧当前对象的selectedIndex 清除
                3.把用orderList有selectedIndex 且大于curIndex 进行selectedIndex 为原来的值-1赋值 毕竟都是走一步的
                4.获取当前项在selectedList对应的索引位置 然后操作selectedList删除对应的所引
                5.更新orderList
            */
           
            const curIndex = item.selectedIndex
            delete item.selectedIndex

            this.orderList.forEach(item => {
                if (item.selectedIndex && (item.selectedIndex > curIndex)) {
                    item.selectedIndex = item.selectedIndex - 1
                }
            })
            
            const splictIndex = this.selectedList.findIndex((currentValue) => {
                return currentValue.id == item.id
            })
            this.selectedList.splice(splictIndex, 1)
            this.refreshOrderList()
        },

        refreshOrderList() {
            this.orderList = JSON.parse(JSON.stringify(this.orderList))
        },

        selectedListItemPush(item) {
            this.selectedList.push(item)
            item.selectedIndex = this.selectedList.length
            this.refreshOrderList()
        },

        selectedChange(orderIndex) {
            const curItem = this.orderList[orderIndex]
            if (curItem.isSelected) {
                // 选中
                curItem.isSelected = false
                this.selectedListItemRemove(curItem)
            } else {
                // 未选中
                curItem.isSelected = true
                this.selectedListItemPush(curItem)
            }

        },

        
    }, 
    beforeRouteLeave(to, from, next) {
        this.checkTimer && clearTimeout(this.checkTimer)
        next()
    },
}
</script>
<style scoped>
    .layoutTop{
        display: flex;
        align-items: center;
        padding: 10px;
        background: #fff;
        margin-bottom: 10px;
    }
    .el-button--success{
        margin-right: 20px;
        height: 35px;
        padding: 0 15px;
    }
    .mapBox{
        padding: 20px;
        background:#fff;
        height: calc(100%  - 105px);
    }
    .map{
        height: 100%;
        overflow: hidden;
    }
    .bm-view {
        width: 100%;
        height: 810px;
    }

     .dialog-content-item-right {
        padding-left: 26px;
        color: #404040;
        font-size: 16px;
    }

     .dialog-content-item-left {
        position: relative;
    }

     .dialog-content-item-line {
        position: absolute;
        left: 9px;
        top: 0;
        bottom: 0;
        width: 1px;
        height: 100%;
        background-color: #D8D8D8;
        z-index: 1;
    }

     .dialog-content-item-text {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        width: 18px;
        height: 18px;
        border: 1px solid #949494;
        border-radius: 2px;
        color: #949494;
        border: none;
        background-color: #FF5B3E;
        color: #fff;
        z-index: 2;
    }

     .dialog-content-item {
        display: flex;
        height: 56px;
    }

     .dialog-content-item:last-of-type {
        height: 22px;
    }

     .dialog-content-item:last-of-type .dialog-content-item-line {
        width: 0;
    }

    .input-item .el-date-editor, .input-item .car-select {
        width: 170px !important;
    }

     .dialog-content {
        min-height: 300px;
        max-height: 300px;
        overflow: auto;
        padding-left: 100px;
    }

    .dialog-footer /deep/.el-date-editor--datetime  .el-input__inner {
        padding-right: 0 !important;
    }
    .dialog-footer  /deep/.el-date-editor--datetime .el-input__inner{
        padding-left: 5px;
    }
    .dialog-footer  /deep/.el-date-editor--datetime .el-input__prefix{
        color: #FF5B3E;
        right: 5px;
        left: auto;
        top: 0;
    }
     .el-select .el-input .el-select__caret,
     .el-input--mini .el-input__icon {
        color: #FF5B3E;
    }

    .order-box .el-checkbox-button__inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        border: none;
        padding: 0;
        background-color: #fff !important;
        border: 1px solid #949494;
        border-color: #949494 !important;
        font-size: 12px !important;
        border-radius: 2px !important;
    }

    .order-box .cell {
        display: flex;
        justify-content: center;
    }

    .order-box .el-checkbox-button {
        vertical-align: middle;
    }
    
</style>
<style scoped>
    .pay-success {
        font-size: 24px;
        color: #FF5B3E;
    }

    .payDialog-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .payDialog-content .pay-qrcode {
        width: 170px;
        height: 170px;
        margin-bottom: 32px;
    }

    .dialog-top-section .input-item>span {
        text-align: left;
        font-size: 14px;
        color: #383838;
        margin-bottom: 2px;
    }

    .dialog-top-section .input-item {
        display: flex;
        flex-direction: column;
        width: 140px;
        justify-content: flex-start;
        margin-right: 20px;
    }

    .dialog-top-section {
        display: flex;
        margin-bottom: 32px;
    }

    .dialog-title {
        color: #404040;
        font-size: 16px;
    }

    .dialog-title span {
        color: #FF5B3E;
        font-size: 24px;
        font-weight: 600;
    }

    .spell-List {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #fff;
    }

    .count-section {
        display: flex;
        padding: 16px 8px;
    }

    .order-box {
        padding: 0 8px;
    }

    .order-table {
        margin: 0 auto;
    }

    .checkbox-input {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        width: 18px;
        height: 18px;
        border: 1px solid #949494;
        border-radius: 2px;
        color: #949494;
    }

    .checkbox-input.is-selected {
        border: none;
        background-color: #FF5B3E;
        color: #fff;
    }
</style>